import { featuredProjects } from "@/data/featuredProjects";
import { Link } from "react-router-dom";

const services = [
  { text: "Hardwood Installation", href: "/installation" },
  { text: "LVP Installation", href: "/lvp-installation" },
  { text: "Waterproof Laminate Installation", href: "/laminate-installation" },
  { text: "Alterna Tile Installation", href: "/alterna-tile-installation" },
  { text: "Dust Control Refinishing", href: "/refinishing" },
  { text: "NWFA Inspection", href: "/inspections" },
  { text: "Subfloor Leveling", href: "/subfloor-leveling" },
  { text: "Water Damage Restoration", href: "/water-damage-flooring" },
  { text: "Staircase Renovations", href: "/staircase-renovations" },
  { text: "Commercial Projects", href: "/commercial" },
  { text: "Product Specification", href: "/product-specification" },
  { text: "Carpet & Stair Runners", href: "/dreamweaver-carpet" },
];

const resources = [
  { text: "Environment & Acclimation", href: "/environment-acclimation" },
  { text: "Reclaimed Barnwood", href: "/reclaimed-barnwood" },
  { text: "Water Damage & Insurance", href: "/water-damage-flooring" },
  { text: "About", href: "/about" },
  { text: "Contact", href: "/contact" },
];

const NavLink = ({ text, href }: { text: string; href: string }) => (
  <li>
    <Link
      to={href}
      className="text-[13px] leading-[2.2] inline-block transition-colors duration-150"
      style={{ color: "var(--footer-text-secondary)" }}
      onMouseEnter={(e) => (e.currentTarget.style.color = "var(--footer-gold)")}
      onMouseLeave={(e) => (e.currentTarget.style.color = "var(--footer-text-secondary)")}
    >
      {text}
    </Link>
  </li>
);

const flooringTypes = [
  { text: "Hardwood Flooring", href: "/hardwood-flooring" },
  { text: "Reclaimed Wood Flooring", href: "/reclaimed-barnwood" },
  { text: "Luxury Vinyl Plank Flooring", href: "/luxury-vinyl-plank-flooring" },
  { text: "Laminate Flooring", href: "/laminate-flooring" },
];

const FooterLinks = () => (
  <div className="flex flex-col">
    <span
      className="text-[11px] font-semibold tracking-[0.08em] uppercase mb-4"
      style={{ color: "var(--footer-text-tertiary)" }}
    >
      Flooring Types
    </span>
    <ul className="flex flex-col">
      {flooringTypes.map((l) => <NavLink key={l.text} {...l} />)}
    </ul>

    <span
      className="text-[11px] font-semibold tracking-[0.08em] uppercase mb-4 mt-8"
      style={{ color: "var(--footer-text-tertiary)" }}
    >
      Services
    </span>
    <ul className="flex flex-col">
      {services.map((l) => <NavLink key={l.text} {...l} />)}
    </ul>

    <span
      className="text-[11px] font-semibold tracking-[0.08em] uppercase mb-4 mt-8"
      style={{ color: "var(--footer-text-tertiary)" }}
    >
      Resources
    </span>
    <ul className="flex flex-col">
      {resources.map((l) => <NavLink key={l.text} {...l} />)}
    </ul>
    <span className="text-[11px] font-semibold tracking-[0.08em] uppercase mb-4 mt-8" style={{ color: "var(--footer-text-tertiary)" }}>Projects</span>
    <span className="text-[11px] mb-2" style={{ color: "var(--footer-text-tertiary)" }}>Featured Homes</span>
    <ul className="flex flex-col">
      {featuredProjects.map(link => <NavLink key={link.href} {...link} />)}
      <NavLink text="All Projects" href="/projects" />
    </ul>
  </div>
);

export default FooterLinks;
